export default [
  {
    id: 1,
    name: 'Lumora Technologies',
    domain: 'lumora.com',
    description: 'Empresa líder em soluções de software para o mercado B2B.',
    city: 'São Paulo',
    countryCode: 'BR',
    contactsCount: 12,
    firstContacts: [],
    avatarUrl: '',
    socialProfiles: {},
  },
  {
    id: 2,
    name: 'Designify Studio',
    domain: 'designify.io',
    description: 'Agência criativa especializada em UX e identidade visual.',
    city: 'Rio de Janeiro',
    countryCode: 'BR',
    contactsCount: 7,
    firstContacts: [],
    avatarUrl: '',
    socialProfiles: {},
  },
  {
    id: 3,
    name: 'CodeHub Brasil',
    domain: 'codehub.com.br',
    description: 'Plataforma de desenvolvimento e consultoria em tecnologia.',
    city: 'Belo Horizonte',
    countryCode: 'BR',
    contactsCount: 5,
    firstContacts: [],
    avatarUrl: '',
    socialProfiles: {},
  },
  {
    id: 4,
    name: 'InnovaTech',
    domain: 'innovatech.com.br',
    description: 'Inovação em produtos digitais para o varejo.',
    city: 'Curitiba',
    countryCode: 'BR',
    contactsCount: 3,
    firstContacts: [],
    avatarUrl: '',
    socialProfiles: {},
  },
  {
    id: 5,
    name: 'OptiSearch',
    domain: 'optisearch.com.br',
    description: 'Especialistas em SEO e tráfego orgânico.',
    city: 'Porto Alegre',
    countryCode: 'BR',
    contactsCount: 9,
    firstContacts: [],
    avatarUrl: '',
    socialProfiles: {},
  },
];
